import Proptypes from 'prop-types';
import React, { useCallback } from 'react';

import { RiFontSize } from 'react-icons/ri';

import NewDropDown from './NewDropDown';
import SelectDropdown from './SelectDropDown';

export default function FontSizeFormatter({ editor, value, darkMode, small = false }) {
  const handleClickOption = useCallback(fontSize => {
    fontSize = fontSize.replace('px', '')
    const newValue = fontSize === 'Normal' || fontSize === value ? null : fontSize.replace('px', '')
    return editor.commands.setFontSize(newValue)
  }, [editor, value])

  if (small) {
    return <NewDropDown
      options={SIZES}
      onClickOption={handleClickOption}
      tooltipText='Font Size'
      icon={RiFontSize}
      editor={editor}
      creatable
      darkMode={darkMode}
    />
  }

  return <SelectDropdown
    options={SIZES}
    onChange={handleClickOption}
    tooltipText='Font Size'
    value={value}
    darkMode={darkMode}
    creatable
  />
}

const SIZES = ['Normal', '8px', '9px', '10px', '11px', '12px', '14px', '18px', '24px', '30px', '36px', '48px', '60px', '72px', '96px']

FontSizeFormatter.propTypes = {
  editor: Proptypes.object,
  tooltipText: Proptypes.string,
}
